import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Linkedin, Twitter, Facebook, Mail } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const navigate = useNavigate();

  const navTo = (path) => {
    navigate(path);
    window.scrollTo(0, 0);
  };

  return (
    <footer className="bg-slate-900 border-t border-slate-800">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Brand Column */}
          <div className="space-y-4">
            <div className="flex items-center space-x-3">
              <img
                src="https://customer-assets.emergentagent.com/job_frosty-it-hub/artifacts/o2t5vwwy_logo.jpeg"
                alt="FrostByte IT Logo"
                className="h-10 w-10 object-contain" />

              <span className="text-xl font-bold text-white">
                FrostByte<span className="text-cyan-400">IT</span>
              </span>
            </div>
            <p className="text-slate-400 text-sm leading-relaxed">
              Professional IT solutions for home users and businesses. Keeping your technology reliable and secure for over 15 years.
            </p>
            {/* Social Links */}
            <div className="flex space-x-4 pt-4">
              <a
                href="#"
                className="w-10 h-10 bg-slate-800 hover:bg-cyan-500 rounded-lg flex items-center justify-center transition-all duration-300 hover:scale-110"
                aria-label="LinkedIn">

                <Linkedin className="w-5 h-5 text-slate-400 hover:text-white" />
              </a>
              <a
                href="#"
                className="w-10 h-10 bg-slate-800 hover:bg-cyan-500 rounded-lg flex items-center justify-center transition-all duration-300 hover:scale-110"
                aria-label="Twitter">

                <Twitter className="w-5 h-5 text-slate-400 hover:text-white" />
              </a>
              <a
                href="#"
                className="w-10 h-10 bg-slate-800 hover:bg-cyan-500 rounded-lg flex items-center justify-center transition-all duration-300 hover:scale-110"
                aria-label="Facebook">

                <Facebook className="w-5 h-5 text-slate-400 hover:text-white" />
              </a>
              <a
                href="mailto:info@frostbyteitmn.com"
                className="w-10 h-10 bg-slate-800 hover:bg-cyan-500 rounded-lg flex items-center justify-center transition-all duration-300 hover:scale-110"
                aria-label="Email">

                <Mail className="w-5 h-5 text-slate-400 hover:text-white" />
              </a>
            </div>
            {/* Faith and Patriotism */}
            <div className="pt-4">
              <img
                src="https://customer-assets.emergentagent.com/job_frosty-it-hub/artifacts/z00el0te_flag.png"
                alt="Faith and Patriotism"
                className="h-16 w-auto object-contain"
                style={{
                  mixBlendMode: 'screen',
                  filter: 'brightness(1.3) contrast(1.4) saturate(1.2)'
                }} />

            </div>
            {/* Other Local Business */}
            <div className="pt-4 mt-4 border-t border-slate-800">
              <p className="text-slate-400 text-sm leading-relaxed">
                Check out our other local business at{' '}
                <a
                  href="https://www.walzsnowremoval.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-cyan-400 hover:text-cyan-300 transition-colors underline">

                  walzsnowremoval.com
                </a>
              </p>
            </div>
          </div>

          {/* Services Column */}
          <div>
            <h3 className="text-white font-semibold mb-4">Services</h3>
            <ul className="space-y-3">
              <li>
                <button onClick={() => navTo('/services/signage')} className="text-slate-400 hover:text-cyan-400 transition-colors duration-200 text-sm">
                  Digital Signage
                </button>
              </li>
              <li>
                <button onClick={() => navTo('/services/websites')} className="text-slate-400 hover:text-cyan-400 transition-colors duration-200 text-sm">
                  Custom Websites
                </button>
              </li>
              <li>
                <button onClick={() => navTo('/services/it')} className="text-slate-400 hover:text-cyan-400 transition-colors duration-200 text-sm">
                  Managed Networks
                </button>
              </li>
              <li>
                <button onClick={() => navTo('/services/it')} className="text-slate-400 hover:text-cyan-400 transition-colors duration-200 text-sm">
                  Router &amp; Wi-Fi Setup
                </button>
              </li>
              <li>
                <button onClick={() => navTo('/services/it')} className="text-slate-400 hover:text-cyan-400 transition-colors duration-200 text-sm">
                  Computer Repair
                </button>
              </li>
              <li>
                <button onClick={() => navTo('/services/it')} className="text-slate-400 hover:text-cyan-400 transition-colors duration-200 text-sm">
                  Security Cameras
                </button>
              </li>
            </ul>
          </div>

          {/* Quick Links Column */}
          <div>
            <h3 className="text-white font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => navTo('/')}
                  className="text-slate-400 hover:text-cyan-400 transition-colors duration-200 text-sm">

                  Home
                </button>
              </li>
              <li>
                <button
                  onClick={() => navTo('/services/signage')}
                  className="text-slate-400 hover:text-cyan-400 transition-colors duration-200 text-sm">

                  Services
                </button>
              </li>
              <li>
                <button
                  onClick={() => navTo('/')}
                  className="text-slate-400 hover:text-cyan-400 transition-colors duration-200 text-sm">
                  About Us
                </button>
              </li>
              <li>
                <button
                  onClick={() => navTo('/contact')}
                  className="text-slate-400 hover:text-cyan-400 transition-colors duration-200 text-sm">

                  Contact
                </button>
              </li>
              <li>
                <button
                  onClick={() => navTo('/support')}
                  className="text-slate-400 hover:text-cyan-400 transition-colors duration-200 text-sm">
                  Support
                </button>
              </li>
            </ul>
          </div>

          {/* Contact Column */}
          <div>
            <h3 className="text-white font-semibold mb-4">Contact Info</h3>
            <ul className="space-y-3 text-sm text-slate-400">
              <li>
                <span className="block font-medium text-white mb-1">Email:</span>
                <a href="mailto:info@frostbyteitmn.com" className="hover:text-cyan-400 transition-colors">
                  info@frostbyteitmn.com
                </a>
              </li>
              <li>
                <span className="block font-medium text-white mb-1">Phone:</span>
                <a href="tel:+12184056066" className="hover:text-cyan-400 transition-colors">218-234-6179

                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-slate-800">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-slate-400 text-sm">
              © 2026 FrostByte IT. All rights reserved.
            </p>
            <div className="flex space-x-6 text-sm">
              <a href="#" className="text-slate-400 hover:text-cyan-400 transition-colors">
                Privacy Policy
              </a>
              <a href="#" className="text-slate-400 hover:text-cyan-400 transition-colors">
                Terms of Service
              </a>
              <a href="#" className="text-slate-400 hover:text-cyan-400 transition-colors">
                Cookie Policy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>);

};

export default Footer;